
/* injects from baggage-loader */
require('./message-modal.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('messageModal', {
    templateUrl: '/app/components/deal-sheet/modals/message-modal.component.html',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});
